import React from 'react';

import BigTitle from "../BigTitle";
import {Helmet} from "react-helmet";
import {FormattedMessage} from "react-intl";
import tech_img from "../../assets/img/services/meet_and_greet/tech_assist.jpg";
import equipment_rental from "../../assets/img/services/meet_and_greet/equipement_rental.jpg";
// import PhotoGallery from "./PhotoGallery";


const meta = require("../../translations/meta.json");

export default class OtherServices extends React.Component {
    render() {
        return <div className={"meet_and_greet"} dir={this.props.lang === "ar" ? "rtl" : "ltr"}>
            {!this.props.no_meta && <Helmet>
                <title>{meta[this.props.lang].other_services.title}</title>
                <meta name="description"
                      content={meta[this.props.lang].other_services.description}
                />




            </Helmet>}

            <div className={"r"}>
                <div className={"c-1-1"}>

                    <BigTitle title={<FormattedMessage id={"meet_and_greet.technical_assistance.title"}/>}/>
                    <img alt="tech_img" className={"tech_img"} src={tech_img}/>
                </div>
            </div>

            <div className={"r"}>
                <div className={"c-1-1"}>
                    <div className={"c-1-1"}>
                        <p><FormattedMessage id={"meet_and_greet.technical_assistance.description.p1"}/></p>
                        <p><FormattedMessage id={"meet_and_greet.technical_assistance.description.p2"}/></p>
                        <p><FormattedMessage id={"meet_and_greet.technical_assistance.description.p3"}/></p>
                        <p><FormattedMessage id={"meet_and_greet.technical_assistance.description.p4"}/></p>
                    </div>
                </div>
            </div>

            <div className={"r"}>
                <div className={"c-1-1"}>

                    <BigTitle title={<FormattedMessage id={"meet_and_greet.equipment_rental.title"}/>}/>
                    <img alt="equipment_rental" className={"equipment_rental"} src={equipment_rental}/>
                </div>
            </div>

            <div className={"r"}>
                <div className={"c-1-1"}>
                    <div className={"c-1-1"}>
                        <p><FormattedMessage id={"meet_and_greet.equipment_rental.description.p1"}/></p>
                        <p><FormattedMessage id={"meet_and_greet.equipment_rental.description.p2"}/></p>
                    </div>
                </div>
            </div>
            {/*
            <div className={"r"}>
                <div className={"c-1-1"}>
                    <BigTitle title="GALLERY"/>
                </div>
            </div>
            <PhotoGallery/>
            */}
        </div>

    }

}


// WEBPACK FOOTER //
// ./src/components/pages/OtherServices.js